import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../../Firebase';
import defaultPollImage from '../../../assets/polls/defaultImage.jpg';
import IconPlus from "../../../assets/cards/icon_plus.svg";
import SinglePoll from "../../Home/SinglePoll";
import Modal from "react-responsive-modal";
import { AnswerPollContent } from '../../AnswerPoll/AnswerPoll';


const styles_desktop = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
    },
    modal: {
        boxShadow: 'none',
        borderRadius: '4px',
        minHeight: "684px",
        maxWidth: "376px",
        top: "10%",
        padding: "0px",
    }
};

const styles_mobile = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
        padding: "0px",
    },
    modal: {
        boxShadow: 'none',
        minHeight: "100%",
        width: "100%",
        padding: "0px",
    }
};

const INITIAL_STATE = {
    answerPollOpen : false,
    answeredPolls : {},
    activePollID : '',
    answerStep : '',
    error: null,
};

class PollsSectionComponent extends Component {

    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    } 

    openAnswerPoll = () => {
        this.setState({
            answerPollOpen: true
        })
    }

    closeAnswerPoll = () => {
        this.setState({
            answerPollOpen: false
        })
    }

    onClick = async pollID => {
        let activePollID = pollID;
        const answeredPolls = this.props.answeredPolls;

        if (answeredPolls[pollID]) {
            this.setState({ activePollID, answerPollOpen: true, answerStep : 'STEP2' });
        }

        else {
            this.setState({ activePollID, answerPollOpen: true, answerStep : 'STEP1' });
        };
    };

    render() {
        const {activePollID, answerStep} = this.state;
        const capsule = this.props.capsule;
        const capsuleID = this.props.capsuleID;
        const polls = this.props.polls;
        const answeredPolls = this.props.answeredPolls;
        

        return (
            <>
                <div className="container">
                    <div className="row no-margin">
                        <div className="col"></div>
                        <div className="col text-center">
                            <h1 className="cps-title mt-2">Les sondages</h1>
                            <button className="button-challenge" type="button" onClick={() => this.props.openCreatePoll()}>
                                <img alt="icon" className="img-btn" src={IconPlus} />
                                Ajouter un sondage</button>
                            <div>
                                <div className="d-flex idea-list pb-3 center-content">
                                    {polls.map((poll, index) => <div className="center-content" key={index}>
                                        <SinglePoll key={index}
                                            src={capsule.image_url_capsule || defaultPollImage}
                                            topic={capsule.tags[0] ? capsule.tags[0] : "#NoTags"}
                                            answered={answeredPolls[poll.id]}
                                            onClick={() => this.onClick(poll.id)} 
                                            pollId={poll.id}
                                            poll={poll}
                                            capsuleId={capsuleID}/>
                                    </div>)}
                                </div>
                            </div>
                        </div>
                        <div className="col"></div>
                    </div>
                </div>
                <Modal
                    open={this.state.answerPollOpen}
                    onClose={this.closeAnswerPoll}
                    center
                    showCloseIcon={true}
                    styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
                >
                    <AnswerPollContent
                        onClose={this.closeAnswerPoll}
                        activePollID={activePollID}
                        activeCapsuleID={capsuleID}
                        markPollAsAnswered={this.props.markPollAsAnswered}
                        answerStep = {answerStep} />

                </Modal>
            </>
        );
    }
}

const PollsSection = withRouter(withFirebase(PollsSectionComponent));

export default PollsSection;